import { Component, Input, ViewEncapsulation, ViewChildren, QueryList, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { element } from 'protractor';

import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
//import { ToasterModule, ToasterService, ToasterConfig } from 'angular2-toaster';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl, FormGroupName} from '@angular/forms';
import { ValidationFormsService } from './validation-forms.service';
import { ValidatorFn, ValidationErrors } from '@angular/forms';
import { ToasterComponent, ToasterPosition } from '@coreui/angular';
import { AppToastComponent as ToastComp } from '../../../services/shared-service/toast-simple/toast.component'
import { HttpService } from '../../../services/http-service/http.service'
import { ModalDirective } from 'ngx-bootstrap/modal';

import { ToastrService } from 'ngx-toastr';
import { LocalInterfaceService } from '../../../services/local-inteface-service/local-interface.service';
import { StorageService } from '../../../services/storege-service/storage.service';
import * as moment from 'moment';
import { ToolService } from '../../../services/tool/tool.service';

@Component({
  //selector: 'app-toasters',
  templateUrl: './basic-forms.component.html',
  styleUrls: ["../../../../../node_modules/ngx-bootstrap/datepicker/bs-datepicker.css",],
  //encapsulation: ViewEncapsulation.None,
  providers: [ ValidationFormsService ]
})


export class BasicFormsComponent {


  minDate = new Date(2017, 5, 10);
  maxDate = new Date(2022, 9, 15);

  bsValue: Date = new Date();

// Timepicker

  public isEnabled: boolean = true;


  public mfData? : object = {};
  public courts?;
  public users?;
  public facilities?;
  isUpdate: boolean = false;
  dbFunction?: string;
  tapFileId: string;
  uploadedImage: File;
  compressedImage: string;
  title: string;
  base64Image: string;
  url: string;
  purpose: string;
  docNumber: string;
  docIssuingCountry: string;
  docIssuingDate: string;
  docExpiryDate: string;
  status: string;
  public facilityId = '';
  public facilityName = '';
  public isLoading = false;
  public purposes?;

  isError: boolean = false;

  simpleForm: FormGroup;
  submitted = false;
  formErrors: any;

  //private toasterService: ToasterService;
  //public toasterconfig: ToasterConfig = new ToasterConfig({tapToDismiss: true, timeout: 5000});
  
  @ViewChild(ToastComp) toastComp: ToastComp;
  @ViewChild('dangerModal', {static: false}) public dangerModal: ModalDirective;

  public paddingStyle: Object = { 'padding-right': '20px'};

  constructor(
    private router: Router, 
    private http: HttpClient, 
    public route: ActivatedRoute,
    private fb: FormBuilder,
    public vf: ValidationFormsService, 
    public httpService: HttpService,
    private toastr: ToastrService,
    private localInterfaceSrv: LocalInterfaceService,
    private storageSrv: StorageService,
    public toolService: ToolService,
    ) {
    //if (localStorage.getItem('currentUser') === null) {this.router.navigateByUrl('/login');}
    if (localStorage.getItem('lang') === "ar") {
      //this.toasterconfig = new ToasterConfig({tapToDismiss: true, timeout: 5000, positionClass: 'toast-top-left'});
    }
    //this.toasterService = toasterService;
    this.formErrors = this.vf.errorMessages;
    //this.facilityId = this.storageSrv.getFacilityId();
    //this.facilityName = this.storageSrv.getFacilityName();

    if(this.router.getCurrentNavigation().extras.state?.createData == null)
    {
      this.isUpdate = true;
      this.dbFunction = 'updateAddonsTable';
      this.mfData = this.router.getCurrentNavigation().extras.state?.data;
      this.tapFileId = this.mfData['id'];
      this.facilityId = this.mfData['facilityId'];
      this.title = this.mfData['fileTitle'];
      this.purpose = this.mfData['filePurpose'];
      this.url = this.mfData['internalFileUrl'];
      this.docNumber = this.mfData['docNumber'];
      this.docIssuingCountry = this.mfData['docIssuingCountry'];
      this.docIssuingDate = this.mfData['docIssuingDate'] != null ? new Date(this.mfData['docIssuingDate'].replace(/-/g, "/")) : this.mfData['docIssuingDate'];
      this.docExpiryDate = this.mfData['docExpiryDate'] != null ? new Date(this.mfData['docExpiryDate'].replace(/-/g, "/")) : this.mfData['docExpiryDate'];

    }
    else
    {
      this.tapFileId = '';
      this.title = '';
      this.facilityId = '';
      this.url = '';
      this.purpose = '';
      this.docNumber = '';
      this.docIssuingCountry = '';
      this.docIssuingDate = '';
      this.docExpiryDate = '';
    }
    this.loadFilePurpose(this.facilityId);
    this.loadActiveFacilities();
    this.createForm();
  }

  isCollapsed: boolean = false;
  iconCollapse: string = 'icon-arrow-up';

  @Input() message : string;
  messages: string[] = [];
  updatedData = this.mfData;

  // Validators.pattern('^[0-9]{4}[\/][1-9]|1[012][\/][0-9]{2}$')]
  createForm() {
    this.simpleForm = this.fb.group({
      facilityId: [this.facilityId, [Validators.required]],
      title: [this.title, [Validators.required]],
      purpose: [this.purpose, [Validators.required]],
      url: [this.url, [Validators.required]],
      docNumber: [this.docNumber, [Validators.required]],
      docIssuingCountry: [this.docIssuingCountry, [Validators.required]],
      docIssuingDate: [this.docIssuingDate, [Validators.required]],
      docExpiryDate: [this.docExpiryDate, [Validators.required]],
    }, { });
  }

  get f() { return this.simpleForm.controls; }

  async showSuccess(msg) {

    await this.toastr.success(msg, 'Success');

    if (this.isUpdate && !this.isError)
    {
      this.delay(2000).then(any=>{
        this.router.navigate(['../'], {relativeTo: this.route}).then(() => {
          //window.location.reload();
        });;
      });  
    }
    else if (!this.isUpdate && this.isError == false)
    {
      this.delay(2000).then(any=>{
        this.router.navigate(['../'], {relativeTo: this.route}).then(() => {
          //window.location.reload();
        });;
      });  
    }
  }

  public findInvalidControls() {
    const invalid = [];
    const controls = this.simpleForm.controls;
    for (const name in controls) {
        if (controls[name].invalid) {
            invalid.push(name);
        }
    }
    return invalid;
}


uploadFile(event) {
  let files = event.target.files;
  this.toolService.showConsoleLog(files);
  const reader = new FileReader();
  if (files.length > 0) {
    this.uploadedImage = files[0]; // You will see the file
    reader.readAsDataURL(this.uploadedImage);
    reader.onload = (_event) => { 
      this.url = reader.result.toString(); 
      this.base64Image = reader.result.toString(); 
  }
  }
}

saveTapFile = () => {
  this.title = this.f['title'].value;
  if (this.title == null || this.title === '' || this.title === ' ' || this.f['purpose'].value == null
  || this.f['docNumber'].value == null  || this.f['docIssuingCountry'].value == null  || this.f['docIssuingDate'].value == null
  || this.f['docExpiryDate'].value == null)
  {
    this.toastr.warning("Required fields are missing", "Warning");
    return;
  }
  if (this.uploadedImage != null)
  {
    this.facilityName = this.facilityName.replace(' ', '-').toLowerCase();
    // this.base64Image = this.url;
    // this.url = 'https://img.arenaclub.io/';
    // var path = 'facilities/' + this.facilityName + '/';
    // this.url = this.url + path;
    // this.simpleForm.controls['url'].setValue(this.uploadedImage.name);
  }

  let formattedIssueDate = (moment(new Date(this.f['docIssuingDate'].value))).format('YYYY-MM-DD');
  let formattedExpiryDate = (moment(new Date(this.f['docExpiryDate'].value))).format('YYYY-MM-DD');

  return new Promise<any>(async (resolve, reject) => {
    this.isLoading = true;
    const fields = {
      tapFileId: this.mfData['id'],
      facilityId: this.f['facilityId'].value,
      title: this.title,
      purpose: this.f['purpose'].value,
      fileImage: this.base64Image,
      docNumber: this.f['docNumber'].value,
      docIssuingCountry: this.f['docIssuingCountry'].value,
      docIssuingDate: formattedIssueDate,
      docExpiryDate: formattedExpiryDate,
    };
    if (this.isUpdate) 
    {
      this.localInterfaceSrv.updateTapFiles(fields)
      .then(async res => {
        resolve(res);
        this.showSuccess('File Updated');
      })
      .catch(err => { 
        reject(err); 
        this.toastr.error(err.desc, "Error");
      })
      .finally(() => this.isLoading = false);
    } 
    else 
    {
      this.localInterfaceSrv.addTapFiles(fields)
      .then(async res => {
        resolve(res);
        this.showSuccess('File Added');
      })
      .catch(err => { 
        reject(err); 
        this.toastr.error(err.desc, "Error");
      })
      .finally(() => this.isLoading = false);
    }
  });
}

  async delay(ms: number) {
    //await new Promise(resolve => setTimeout(()=>resolve(), ms)).then(()=>this.toolService.showConsoleLog("fired"));
  }

  collapsed(event: any): void {
    // this.toolService.showConsoleLog(event);
  }

  updateData(name: string): void {
    this.updateData['nameEn'] = name;
  }
 
  expanded(event: any): void {
    // this.toolService.showConsoleLog(event);
  }

  toggleCollapse(): void {
    this.isCollapsed = !this.isCollapsed;
    this.iconCollapse = this.isCollapsed ? 'icon-arrow-down' : 'icon-arrow-up';
  }
  deleteTapFile = (TapFileId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      const fields = {
        TapFileId: TapFileId
      };
      this.localInterfaceSrv.deleteTapFiles(TapFileId)
      .then(async res => {
        resolve(res);
        this.toastr.success("File Removed", "Success");
        this.dangerModal.hide();
        this.router.navigate(['../'], {relativeTo: this.route}).then(() => {
        });
      })
      .catch(err => { 
        reject(err); 
        this.toastr.error(err.desc, "Error");
        this.dangerModal.hide();
      })
      .finally(() => this.isLoading = false);
    });
  }
  loadFilePurpose = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.getTapFilePurpose(facilityId)
      .then(res => {
        this.purposes = res.content;
        this.isLoading = false;
        resolve(res);
      })
      .catch(err => { 
        reject(err); 
        this.toolService.showConsoleLog(err)
      })
      .finally();
    });
  }
  loadActiveFacilities = () => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.getActiveFacilities()
      .then(res => {
        this.facilities = res.content;
        resolve(res);
      })
      .catch(err => { 
        reject(err); 
        this.toolService.showConsoleLog(err)
        this.toastr.error(err.desc, "Error");
      })
      .finally();
    });
  }
}
